import { queryOptions } from '@tanstack/react-query';
import { workflowApi } from './workflow.api';

export const workflowKeys = {
  stages: ['workflow', 'stages'] as const
};

export const workflowQueries = {
  stages: () =>
    queryOptions({
      queryKey: workflowKeys.stages,
      queryFn: () => workflowApi.getStages(),
      // The order changes only with a deploy.
      staleTime: 60 * 60 * 1000
    })
};
